<script>
import CrudList from 'Arch/components/crud/CrudList.vue';
import BanksRequest from 'Modules/contacard/banks/BanksRequest';

export default {
  name: 'BanksCrudList',
  extends: CrudList,
  data: () => ({
    requestClass: BanksRequest,
    editRoute: 'contacard.banks.edit',
    headers: [
      {
        text: 'Nome do banco',
        value: 'name',
        width: '45%',
      },
      {
        text: 'Código do banco',
        value: 'code',
        width: '30%',
      },
      {
        text: 'Imagem',
        value: 'logo',
        component: 'DataTableImgRow',
        width: '25%',
      },
    ],
  }),
};
</script>
